import { render, staticRenderFns } from "./ProjectsPendingToPublicate.vue?vue&type=template&id=73b85afa&scoped=true&"
import script from "./ProjectsPendingToPublicate.vue?vue&type=script&lang=js&"
export * from "./ProjectsPendingToPublicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b85afa",
  null
  
)

export default component.exports